import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../TopicSection'
import { getSubTopics } from '../../reducers'
import { useSelector } from 'react-redux'

const NUM_VISIBLE_POSTS = 4

interface FriendsAndFamilyViewProps {
  slug: string
}

const FriendsAndFamilyView = ({ slug }: FriendsAndFamilyViewProps) => {
  const state = useSelector((state: any) => state)
  const { posts } = state
  const subTopics = getSubTopics(state, slug)

  return (
    <>
      {subTopics.map((childTopic: Topic) => (
        <TopicSection
          key={`topic_section_${childTopic.slug}`}
          topic={{ name: childTopic.name, slug: childTopic.slug }}
          showTopics={false}
          posts={filterPostsByTopicSlug(posts, childTopic.slug).slice(
            0,
            NUM_VISIBLE_POSTS
          )}
        />
      ))}
    </>
  )
}

export default FriendsAndFamilyView
